import api from '../index';

const shipmentUpdaters = {
  ship: async ({
    shipmentId,
    trackingCode,
  }: {
    shipmentId: string;
    trackingCode: string;
  }) => {
    const body = {data: {tracking_code: trackingCode}};
    return api.put(`/shipments/${shipmentId}/ship`, body, {
      customSerializer: () => body,
    });
  },

  assumeDelivery: async ({shipmentId}: {shipmentId: string}) => {
    const body = {data: {}};
    return api.put(`/shipments/${shipmentId}/assume_delivery`, body, {
      customSerializer: () => body,
    });
  },
};

export default shipmentUpdaters;
